import React from 'react';
import {
  Label,
  PaymentInformationWrapper,
  Row,
  Value,
} from './AutopayPaymentInformation.styles';
import { PaymentMethodType } from '../../../constants';
import { formatCurrency } from '../../../utils/CurrencyUtils';
import { formatDate } from '../../../utils/dateUtils';

const AutopayPaymentInformation = (props: {
  autopayDetails: any;
  autopayDetailsPrompt: any;
}) => {
  const {
    autopayDetails,
    autopayDetailsPrompt: { amountDueDate },
  } = props;
  const {
    withdrawAmount,
    last4AccountNumber,
    paymentMethodType,
  } = autopayDetails;

  const payment = formatCurrency(withdrawAmount);

  const formatAccountType = (accountType: any) => {
    return accountType === PaymentMethodType.CHECKING.toLowerCase() ? (
      <div>[X]Checking &nbsp;&nbsp;&nbsp;[&nbsp;]Savings</div>
    ) : (
      <div>[&nbsp;]Checking &nbsp;&nbsp;&nbsp; [X]Savings</div>
    );
  };

  const PaymentInfoRow = (_props: { label: string; value: any }) => {
    const { label, value } = _props;
    return (
      <Row>
        <Label>{label}:</Label>
        <Value>{value}</Value>
      </Row>
    );
  };

  return (
    <PaymentInformationWrapper>
      <PaymentInfoRow label="Monthly Amount" value={payment} />
      <PaymentInfoRow label="Start Date" value={formatDate(amountDueDate)} />
      <PaymentInfoRow label="Frequency" value="Monthly" />
      <PaymentInfoRow
        label="Bank Account Ending In"
        value={last4AccountNumber}
      />
      <PaymentInfoRow
        label="Account Type"
        value={formatAccountType(paymentMethodType)}
      />
    </PaymentInformationWrapper>
  );
};
export default AutopayPaymentInformation;
